import React from "react";
import "./header.css";
import Logo from "../../assets/icons/logo.png";
import Facebook from "../../assets/icons/facebook.png";
import Instagram from "../../assets/icons/instagram.png";
import WhatsApp from "../../assets/icons/whatsapp.png";
import Email from "../../assets/icons/email.png";
import "../language/language.js";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Button } from "antd";
import { LOCALS } from "../data/constants.js";

const EMAIL = process.env.REACT_APP_EMAIL;
const PHONE = process.env.REACT_APP_PHONE;
const WHATSAPP = process.env.REACT_APP_WHATSAPP;
const FACEBOOK = process.env.REACT_APP_FACEBOOK;
const INSTAGRAM = process.env.REACT_APP_INSTAGRAM;

export default function Header() {
    const { t } = useTranslation();
    const emailData = "mailto:" + EMAIL + "?subject=" + t("header_email");

    return (
        <div className="header">
            <div className="header__container">
                <div className="header__logo">
                    <img src={Logo} alt="logo" />
                    <h2>{t("logo_name")}</h2>
                </div>
                <div className="header__connect">
                    <div className="header__connect__text">
                        {t("header_connect")}
                    </div>
                    <div className="header__connect__icon">
                        <a href={emailData}>
                            <img src={Email} alt="Email" />
                        </a>
                        <a href={WHATSAPP} target="blank">
                            <img src={WhatsApp} alt="WhatsApp" />
                        </a>
                        <a href={FACEBOOK} target="blank">
                            <img src={Facebook} alt="Facebook" />
                        </a>
                        <a href={INSTAGRAM} target="blank">
                            <img src={Instagram} alt="Instagram" />
                        </a>
                    </div>
                </div>
                <div className="header__telephone">
                    <div className="header__telephone__text">
                        <p>{t("header_mode")}</p>
                    </div>
                    <div className="header__telephone__text">
                        <h2> + {String(PHONE)} </h2>
                    </div>
                    <div className="header__telephone__language">
                        <Button
                            size="small"
                            disabled={i18next.language === LOCALS.CS}
                            onClick={() => i18next.changeLanguage(LOCALS.CS)}
                        >
                            čeština
                        </Button>
                        <Button
                            size="small"
                            disabled={i18next.language === LOCALS.UK}
                            onClick={() => i18next.changeLanguage(LOCALS.UK)}
                        >
                            українська
                        </Button>
                        <Button
                            size="small"
                            disabled={i18next.language === LOCALS.RU}
                            onClick={() => i18next.changeLanguage(LOCALS.RU)}
                        >
                            русский
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
